<div class="title">Parameters ({{ parameters.length }})</div>
<div class="body">
  @for (parameter of parameters; track parameter; let i = $index) {
  <div class="card">
    <div class="label">{{ i + 1 }}. {{ parameter.label }}</div>
    <div>
      <span class="value">{{ parameter.value | ParameterValueFormat }}</span>
      @if (parameter.type == '1') {
      <span class="unit"> {{ parameter.unit }}</span>
      }
    </div>
  </div>
  }
</div>
